import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-99f3b9d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, "Puntos de monitorización", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, { class: "card" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_el_table, {
        data: _ctx.satelitalList,
        stripe: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('label.name')
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_link, {
                type: "primary",
                onClick: ($event: any) => (_ctx.changeSatelital(scope.row)),
                disabled: scope.row.id === _ctx.satelitalOpen || !scope.row.lastImage
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(scope.row.samplingPoint.name), 1)
                ]),
                _: 2
              }, 1032, ["onClick", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, { label: "Última imagen" }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.lastImage ? _ctx.formatDate(scope.row.lastImage) : _ctx.$t("label.noProcess")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _: 1
  }))
}